module.exports = __webpack_public_path__ + "static/media/Favorite.e634a56f.PNG";